 
	import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';    
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options  } from "vue-class-component";     
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
	import $ from "jquery"    
    import PatrimonioService from   "@/service/v1/sigap/PatrimonioService"  
    import Multiselect from '@vueform/multiselect'
    import Arquivo from   "./File.vue" 
    import Sgpm from   "./FileSgpm.vue" 

    @Options({
        name: "MatriculaIndex",
        components: { Sgpm, Arquivo, CardRh , KDataTable ,  Multiselect },   
    }) 
    export default class MatriculaIndex extends IndexModelTable {
         
        public isSiga  = null;
        public isSgb  = null; 
        public matricularlote  = false;
        public matricularlotesgpm  = false;
 
        public ativarmatriculalote(){
            this.matricularlote= true;
        }
          
        public cadastradosiga(item){
            this.matricularlote= false;
            this.modeloAlterado(item);
        }
 
        get limimar_select(){
            return [ 
                { value: true , label: "Sim" } ,
                { value: false , label: "Não" } ,
            ];  
        }
         
        public ativarmatriculalotesgpm(){
            this.matricularlotesgpm= true;
        }
        
        public cadastradosgpm(item){
            this.matricularlotesgpm= false;
            this.modeloAlterado(item);
        }
   
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
 
        created(){
            this.service = new PatrimonioService();   
            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {    
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "numeroPatrimonio": () => (document.querySelector('[data-kt-docs-table-filter="NumeroPatrimonio"]')! as HTMLInputElement).value ,   
                        "tipo": () => (document.querySelector('[data-kt-docs-table-filter="tipo"]')! as HTMLInputElement).value ,   
                        "isSiga": () => (document.querySelector('[data-kt-docs-table-filter="isSiga"]')! as HTMLInputElement).value ,   
                        "isSgb": () => (document.querySelector('[data-kt-docs-table-filter="isSgb"]')! as HTMLInputElement).value ,   
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
  
            this.config.columns = [ 
                { data: 'numeroPatrimonio', name: 'numeroPatrimonio' }, 
                { data: 'numeroSerie', name: 'numeroSerie' }, 
                { data: 'numeroSerieSGPM', name: 'numeroSerieSGPM' }, 
                { data: 'statusSGPM', name: 'statusSGPM' }, 
                { data: 'marca', name: 'marca' }, 
                { data: 'marcaSGPM', name: 'marcaSGPM' }, 
                { data: 'estadoConservacao', name: 'estadoConservacao' }, 
                { data: 'setor', name: 'setor' }, 
                { data: 'valorLiquido', name: 'valorLiquido' }, 
                
            ];
            
            this.pushColunaAcoes()
            this.config.columnDefs = [  
                 
            ];   
            
        }     
          
        public tableatualizada( event ) {    
            $('[btn-show]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('id');    
                window.open('/#/sigap/matricula/' +  id, "_blank" ) 
            }); 
        } 
          
        public excluirTudo() {  
            this.processando = true; 
            this.service.excluirTudo( )
            .then(response => {  
                this.processando = false; 
            })
            .catch(error => {  
                this.processando = false; 
                console.log(error);
            })
            .finally( () => {
                this.refreshTable();
                this.processando = false;
            });    
        } 
        
        
        public getSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/Siades?token=' +  this.token );
		}
        
        public getSGB() {  
            window.open( this.service.getApiUrl() + '/Excel/Sgb?token=' +  this.token );
		}
        
        public getSGBComumSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbComumSiades?token=' +  this.token );
		}
  
        public getSomenteSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/SomenteSiades?token=' +  this.token );
		}
  
        public getSomenteSgb() {  
            window.open( this.service.getApiUrl() + '/Excel/SomenteSgb?token=' +  this.token );
		}
 
  
        public getSgbSiadesForaCaixa() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbSiadesForaCaixa?token=' +  this.token );
		}
 
  
        public getSgbBaixadoAindaNoSiades() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbBaixadoAindaNoSiades?token=' +  this.token );
		}
 

    } 
